export class AutoReload {
    constructor(element) {
        this.element = element;
        element.on("change", () => this.reload());
    }
    get selectedOption() {
        return this.element.find("option:selected");
    }
    reload() {
        const url = this.selectedOption.data("url");
        if (url) {
            window.location.href = url;
        }
    }
    static initialize() {
        $("select.auto-reload").each((index, element) => {
            new AutoReload($(element));
        });
    }
}
